import GeneratingKeyPairsWindows from "../../../../src/courses/partials/ssh/windows/generating-key-pairs.mdx";
import * as React from 'react';
export default {
  GeneratingKeyPairsWindows,
  React
};